import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import EventBus from '@vertical-plus/vue-js-core/dist/util/event/event-bus';
import MeetingForm from '../meeting-form/index.vue';
import Techspec from '@/model/entity/job/techspec';

@Component({
    components:
    {
        'app-meeting-form': MeetingForm,
    },
})
export default class MeetingPopupForm extends Vue
{
    @Prop({
        type: Boolean,
        default: false,
    })
    private value!: boolean;

    @Prop()
    private meeting!: Techspec;

    private visible = false;
    private saving = false;

    created()
    {
        this.visible = this.value;
    }

    @Watch('value')
    private onValueChanged()
    {
        this.visible = this.value;
    }

    @Watch('visible')
    private onDialogValueUpdated()
    {
        this.$emit('input', this.visible);
    }

    /**
     * Handles cancel button
     */

    private onCancel()
    {
        this.visible = false;
    }

    /**
     * Handles form saves
     *
     * @param meeting
     */

    private async onSave(meeting: Techspec)
    {
        try
        {
            this.saving = true;

            if (meeting.id)
            {
                const updated = await this.$serviceContainer.techspecService.updateTechspec(meeting);

                EventBus.instance.$emit('meeting-updated', updated);
            }
            else
            {
                const created = await this.$serviceContainer.techspecService.createTechspec(meeting);

                if (created.id)
                {
                    this.$router.push({
                        name: 'meeting-view',
                        params: {
                            id: created.id.toString(),
                        },
                    }).catch();
                }
            }

            EventBus.instance.$emit(
                'notification',
                this.$t('general.message.saved_successfully'),
                'success',
            );
        }
        catch (error: unknown)
        {
            EventBus.instance.$emit(
                'notification',
                this.$t('general.error.failed_saving_server_error'),
                'error',
            );
        }
        finally
        {
            this.visible = false;
            this.saving = false;
        }
    }
}